import { FoodFactContext } from "../context/FoodFactContext";
import { useContext } from "react";

export const useFoodFactContext = () => {
    const context = useContext(FoodFactContext);

    if (!context) {
        return Error('useFoodFactContext must be used inside an FoodFactContextProvider');
    };

    return context;
};